<template>
  <ClicColInterno
    alignSelf="end"
    :cp="cp"
    :key="componentKey"
  >
    <div class="form-group">
      <div v-if="(alignSelf || 'end') == 'end'">&nbsp;</div>
      <div class="form-control-wrap">
        <b-form-checkbox
          :aria-label="ariaLabel"
          :aria-labelledby="ariaLabelledby"
          :autofocus="autofocus"
          :button="button"
          :button-variant="buttonVariant"
          :checked="checked"
          :disabled="disabled"
          :form="form"
          :indeterminate="indeterminate"
          :inline="inline"
          :name="name"
          :plain="plain"
          :required="required"
          :size="size"
          :state="state"
          :switch=false
          :unchecked-value="uncheckedValue"
          v-model="value"
          @change="change"
          @input="input"
        >
          {{ $storage.getTextoTraduzido(label) }}
          <ClicHintInterno
            v-if="hintText"
            :cp="cp"
          />
      </b-form-checkbox>
      </div>
    </div>
     
  </ClicColInterno>
</template>

<script>

import ComponentMixin from '../../core/ComponentMixin';
import { BFormCheckbox } from 'bootstrap-vue';

export default {
  name: 'ClicCheckbox',
  mixins: [ComponentMixin],
  components: { BFormCheckbox },

  methods: {
    
    change(checked) {
      if  (this.lodash.has(this.cp, 'events.change')) {
        this._execEvent('change', { checked });
      }
    },
    
    input(checked) {
      if  (this.lodash.has(this.cp, 'events.input')) {
        this._execEvent('input', { checked });
      }
    }

  },
};
</script>
